 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"faq":"faq","vendors~live":"vendors~live","live":"live","notfound":"notfound","tanyaCusom~tanyaPorto~tanyaSaham":"tanyaCusom~tanyaPorto~tanyaSaham","tanyaCusom":"tanyaCusom","vendors~questionHistory":"vendors~questionHistory","questionHistory":"questionHistory","vendors~tanyaPorto~tanyaSaham":"vendors~tanyaPorto~tanyaSaham","tanyaPorto":"tanyaPorto","tanyaSaham":"tanyaSaham","home":"home","contentAnalysis":"contentAnalysis","contentAnalysisDetail":"contentAnalysisDetail","contentEducation":"contentEducation","contentEducationDetail":"contentEducationDetail","createpassword":"createpassword","faqDetail":"faqDetail","forget":"forget","landingpage":"landingpage","login":"login","notification":"notification","promotion":"promotion","questionAnswer":"questionAnswer","questionHistoryDetail":"questionHistoryDetail","searchStocks":"searchStocks","signup":"signup","stockDetails":"stockDetails","vendors~chart":"vendors~chart","chart":"chart","vendors~dashboard":"vendors~dashboard","dashboard":"dashboard","vendors~profile":"vendors~profile","profile":"profile"}[chunkId]||chunkId) + ".1.0.0." + "c6adda74" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"faq":1,"vendors~live":1,"live":1,"chunk-44b47bf2":1,"chunk-c50ebaa8":1,"tanyaCusom~tanyaPorto~tanyaSaham":1,"tanyaCusom":1,"vendors~questionHistory":1,"questionHistory":1,"vendors~tanyaPorto~tanyaSaham":1,"tanyaPorto":1,"tanyaSaham":1,"home":1,"contentAnalysis":1,"contentAnalysisDetail":1,"contentEducation":1,"contentEducationDetail":1,"createpassword":1,"faqDetail":1,"forget":1,"landingpage":1,"login":1,"notification":1,"promotion":1,"questionAnswer":1,"questionHistoryDetail":1,"searchStocks":1,"signup":1,"stockDetails":1,"chart":1,"vendors~dashboard":1,"dashboard":1,"profile":1,"chunk-22954c8a":1,"chunk-c356c286":1,"chunk-52b6ff25":1,"chunk-c7b28b4a":1,"chunk-1bfa4216":1,"chunk-bd20cbac":1,"chunk-7b3fdd65":1,"chunk-7d3b907b":1,"chunk-0be7ce56":1,"chunk-2ecab4c0":1,"chunk-36e22aa4":1,"chunk-4f52201a":1,"chunk-5c67529e":1,"chunk-6189d354":1,"chunk-6f4d35b6":1,"chunk-84a0d008":1,"chunk-c83a8102":1,"chunk-e7d37722":1,"chunk-044492e0":1,"chunk-0f5a8f51":1,"chunk-90f54176":1,"chunk-454cbafc":1,"chunk-0641c226":1,"chunk-397162ac":1,"chunk-4b0581e7":1,"chunk-7c97896b":1,"chunk-2c4b17ff":1,"chunk-6fc2c580":1,"chunk-beb31784":1,"chunk-3c7b77ec":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"faq":"faq","vendors~live":"vendors~live","live":"live","notfound":"notfound","tanyaCusom~tanyaPorto~tanyaSaham":"tanyaCusom~tanyaPorto~tanyaSaham","tanyaCusom":"tanyaCusom","vendors~questionHistory":"vendors~questionHistory","questionHistory":"questionHistory","vendors~tanyaPorto~tanyaSaham":"vendors~tanyaPorto~tanyaSaham","tanyaPorto":"tanyaPorto","tanyaSaham":"tanyaSaham","home":"home","contentAnalysis":"contentAnalysis","contentAnalysisDetail":"contentAnalysisDetail","contentEducation":"contentEducation","contentEducationDetail":"contentEducationDetail","createpassword":"createpassword","faqDetail":"faqDetail","forget":"forget","landingpage":"landingpage","login":"login","notification":"notification","promotion":"promotion","questionAnswer":"questionAnswer","questionHistoryDetail":"questionHistoryDetail","searchStocks":"searchStocks","signup":"signup","stockDetails":"stockDetails","vendors~chart":"vendors~chart","chart":"chart","vendors~dashboard":"vendors~dashboard","dashboard":"dashboard","vendors~profile":"vendors~profile","profile":"profile"}[chunkId]||chunkId) + "." + {"chunk-23cc8038":"31d6cfe0","chunk-1ecbf08e":"31d6cfe0","faq":"9b07ba3a","chunk-2d0e2288":"31d6cfe0","vendors~live":"abe42924","live":"f1d88652","chunk-44b47bf2":"abe42924","chunk-c50ebaa8":"85cc37a0","notfound":"31d6cfe0","tanyaCusom~tanyaPorto~tanyaSaham":"5e99b05f","tanyaCusom":"9c9c5ec5","vendors~questionHistory":"71bb7e10","questionHistory":"cff8b052","vendors~tanyaPorto~tanyaSaham":"ab78de82","tanyaPorto":"e4a9daf6","tanyaSaham":"4772deca","home":"68469e39","contentAnalysis":"5f24590b","contentAnalysisDetail":"81b0dc5f","contentEducation":"a403f7e4","contentEducationDetail":"a76c1788","createpassword":"bde592bc","faqDetail":"d1e4b693","forget":"2ae9db02","landingpage":"9e7afb34","login":"fd5792a3","notification":"8ce3dc49","promotion":"057a4ec8","questionAnswer":"46a37005","questionHistoryDetail":"09d69fda","searchStocks":"7cde5ccc","signup":"6bde1dd0","stockDetails":"fb40f4e5","vendors~chart":"31d6cfe0","chart":"6d9cab17","vendors~dashboard":"a7750e10","dashboard":"70224684","vendors~profile":"31d6cfe0","profile":"4fc4b4a1","chunk-22954c8a":"63d7d9b6","chunk-2d23840b":"31d6cfe0","chunk-c356c286":"79b9a06e","chunk-52b6ff25":"7e002255","chunk-c7b28b4a":"03ef6ff1","chunk-1bfa4216":"79b9a06e","chunk-bd20cbac":"7e002255","chunk-7b3fdd65":"dbb909fb","chunk-7d3b907b":"7d280a1f","chunk-0be7ce56":"ad187a3b","chunk-2ecab4c0":"b700bfa9","chunk-36e22aa4":"bda06196","chunk-4f52201a":"e5a5a42b","chunk-5c67529e":"48e7e827","chunk-6189d354":"3e502304","chunk-6f4d35b6":"8b6000d6","chunk-84a0d008":"3817e144","chunk-c83a8102":"705f774c","chunk-e7d37722":"56b6b419","chunk-044492e0":"db4c3f24","chunk-0f5a8f51":"eb09352e","chunk-90f54176":"7e002255","chunk-454cbafc":"fd733c83","chunk-0641c226":"a17274a0","chunk-397162ac":"7a9d3775","chunk-4b0581e7":"a200d23e","chunk-7c97896b":"1d71b607","chunk-2c4b17ff":"bebbc615","chunk-6fc2c580":"761ce93d","chunk-beb31784":"df7d9b85","chunk-3c7b77ec":"d51ac883"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
